import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import TrainerImg from "../../../assets/images/png/trainer/trainer-large.webp";

const stats = [
  { title: "Practical", desc: "Industry-led teaching" },
  { title: "Supported", desc: "Faculty and delivery collaboration" },
  { title: "Human", desc: "Mentorship and feedback" },
  { title: "Global", desc: "A connected learning community" },
];

const TrainerHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      style={{ backgroundImage: "linear-gradient(#fff 0%, #f7f9ff 100%)" }}
    >
      <HeaderNavigation />
      <GroupSubNav />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-12 lg:gap-10">
          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Become a Utiva Trainer
              </p>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-poppins tracking-[-0.03em] leading-[1.05] font-black mb-7 text-primary">
                Teach. Mentor. Build the next generation of{" "}
                <mark
                  className="bg-secondary text-primary px-1"
                  style={{
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                  }}
                >
                  talent.
                </mark>
              </h1>

              <p className="font-poppins text-lg md:text-xl text-gray leading-relaxed mb-9 max-w-xl">
                Bring your professional experience into a practical learning
                community. Utiva provides the curriculum context, platform and
                faculty support to help you guide ambitious learners.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg">
                <Link
                  to="/be-a-trainer/get-started"
                  className="text-white bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center gap-2 font-bold shadow-course-feature focus:outline-none"
                >
                  Apply to Become a Trainer
                  <span aria-hidden="true">↗</span>
                </Link>
                <a
                  href="#journey"
                  className="text-primary border-2 border-primary font-poppins px-8 py-4 rounded-xl inline-flex items-center gap-2 font-bold hover:bg-primary hover:text-white transition-colors"
                >
                  See the process
                  <span aria-hidden="true">↓</span>
                </a>
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "580px" }}
              >
                <img
                  src={TrainerImg}
                  alt="A Utiva faculty trainer"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "40%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.92))",
                  }}
                ></div>

                <div className="absolute z-10 bottom-6 left-6 right-6 border-l-4 border-secondary bg-primary backdrop-blur px-5 py-4 font-poppins">
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-1">
                    Practitioners, not just presenters
                  </p>
                  <strong className="text-white text-base font-extrabold">
                    Teach from experience. Mentor with intention.
                  </strong>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>

      <div className="border-t border-hire-line bg-hire-tint-blue">
        <div className="container mx-auto px-4 py-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={stat.title}
              className={
                index !== stats.length - 1
                  ? "lg:border-r lg:border-hire-line lg:pr-6"
                  : ""
              }
            >
              <strong className="block font-poppins font-extrabold text-primary text-lg mb-1">
                {stat.title}
              </strong>
              <span className="text-gray font-poppins text-sm">
                {stat.desc}
              </span>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default TrainerHeaderSection;
